import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./StudentNotification.css";
import { useGetAllAnnouncements } from "../../../../hooks/organization/notification/useGetAllAnnouncements";
import { StudentNotificationSkeleton } from "./StudentNotificationSkeleton";
import { StudentNotificationList } from "./StudentNotificationList";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";
import { STUDENT_ROLE_CONFIG } from "./StudentRolesTab";
import { Button } from "react-bootstrap";
import { useAuth } from "../../../context/LoginContext/AuthContext";

export const SchlStudentNotifications = ({ type }) => {
  const ITEMS_PER_LOAD = 5;
  const { announcements, meta, loading, error, getAllAnnouncements } =
    useGetAllAnnouncements();
  const [page, setPage] = useState(1);
  const [allNotifications, setAllNotifications] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const { currentUser } = useTenantAuth();
  const { user } = useAuth();

  const role =
    type === "pcnormal" ? user?.user?.role_slug : currentUser?.role_slug;

  // console.log("authUser:", role);
 

  const handleBack = () => {
    const backRoute = STUDENT_ROLE_CONFIG[role]?.notification?.gobackhome;
    if (backRoute) navigate(backRoute);
  };

  useEffect(() => {
    fetchNotifications(1);
  }, [type]);

  const fetchNotifications = async (pageNumber) => {
    await getAllAnnouncements({
      page: pageNumber,
      per_page: ITEMS_PER_LOAD,
      type,
    });
  };

  useEffect(() => {
    if (Array.isArray(announcements)) {
      if (page === 1) {
        setAllNotifications(announcements);
      } else {
        setAllNotifications((prev) => [...prev, ...announcements]);
      }

      if (meta?.current_page >= meta?.last_page) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    }
  }, [announcements]);

  const handleLoadMore = async () => {
    const nextPage = page + 1;
    setPage(nextPage);
    await fetchNotifications(nextPage);
  };

  return (
    <div className="container py-4">
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="mb-0">Notifications</h4>
        <Button onClick={handleBack} className="btn btn-sm">
          Back to Dashboard
        </Button>
      </div>

      {error && <div className="text-danger text-center">{error}</div>}

      {loading && page === 1 ? (
        <StudentNotificationSkeleton count={5} />
      ) : (
        <StudentNotificationList
          notifications={allNotifications}
          loading={loading}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
          role={role}
        />
      )}
    </div>
  );
};
